import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { promoCodeLoadPartnerCodes, promoCodeCreate, promoCodeEdit } from './promo-code-sagas'


export function* watchPromoCodeLoadPage() {
  yield* takeEvery(actions.PROMO_CODE_LOAD_PARTNER_CODES, promoCodeLoadPartnerCodes)
}

export function* watchPromoCodeCreate() {
  yield* takeEvery(actions.PROMO_CODE_CREATE, promoCodeCreate)
}

export function* watchPromoCodeEdit() {
  yield* takeEvery(actions.PROMO_CODE_EDIT, promoCodeEdit)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/promo-code/promo-code-watchers.js
 **/